module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAUNJREFUOBFjYCARNDQ08CFrYUTmEGKXlZX5/fv3by1Q3VIeHp4koGH/WAhpQpb///+/AxCD9MR/+fKFEWhAIlEGlJaWhgI1FjMyMuYBNWsBsTuQH/f169dHBA0Aag4HOnspUBPz379/tzMzM3sCaSAXbMgjvGGArBmkAwreAWlroEGMXV1d15lgoug0Ds0gZUJMTExKIM0gDlYD8GhmAGou7+7u3gbSDAIYXiBCcxdEK4REMYBUzSguIEcz3ICSkhIdYLxeAAowQxyGIIFxX9bT09ONEEFlMQFttgUmy29AhY9QpYABREAzSD0T0GZ3YLJcy8nJ6Q/UcB9mCDGawQYACXmgIQbfv39fBDXkEDCqCvA5G2YJiGYBalaACugADWkEescZmEn+QMUIUiysrKx5wGT5Rl9f/1lYWBg4kRPUhaQAAPjMlvn3Aam/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_edit.png
// module id = 218
// module chunks = 170